import React from 'react';
import { Box, HStack, Label, Text, IconButton, Divider, InfoBadge, Icon } from '@medely/ui-kit';
import { useShiftSwapMutations } from './mutations';
import { DisplayHelpers, useProNavigate } from '@mp';
import { FragmentType, parseFragmentData } from '@mp/graphql/generated';
import { ShiftSwapJobFragmentGql } from './graphql';

type ShiftSwapReviewItemProps = {
  job: FragmentType<typeof ShiftSwapJobFragmentGql> | null;
  shiftRequestId?: number | null;
};

export const ShiftSwapReviewItem = ({
  job: inputJob,
  shiftRequestId,
}: ShiftSwapReviewItemProps) => {
  const job = parseFragmentData(ShiftSwapJobFragmentGql, inputJob);
  const { acceptSwapOffer, declineSwapOffer, isLoading } = useShiftSwapMutations();
  const { navigate } = useProNavigate();

  return (
    <Box onClick={() => navigate('AvailableJobDetails', { id: job?.id as number })}>
      <HStack justifyContent="space-between" width="100%" my={4}>
        <Box>
          <Label size="m">
            {DisplayHelpers.job.weekdayShortDate({
              startDate: job?.starts_date,
              timezone: job?.location?.timezone_lookup,
            })}
          </Label>
          <Text size="m" color="text.secondary">
            {DisplayHelpers.job.timeFromRange({
              starts_time: job?.starts_time,
              ends_time: job?.ends_time,
              timezone: job?.location?.timezone_lookup,
            })}
          </Text>
          <Text size="m" color="text.secondary">
            {DisplayHelpers.job.positions(job?.positions)}
          </Text>

          <Box alignSelf="flex-start" my={1}>
            <InfoBadge
              label="Shift Swap"
              color="info"
              icon={
                <Icon
                  name="light-arrows-repeat"
                  variant="custom"
                  iconSize="12px"
                  color="text.secondary"
                />
              }
            />
          </Box>
        </Box>
        <HStack mr={0.75} justifyContent={'center'} alignItems={'flex-start'} gap={2}>
          <IconButton
            onClick={() => declineSwapOffer(shiftRequestId)}
            icon="light-ban"
            tooltip="Decline Swap"
            variant="outlined"
            disabled={isLoading}
          />
          <IconButton
            onClick={() => acceptSwapOffer(shiftRequestId)}
            icon="check"
            tooltip="Accept Swap"
            color="secondary"
            disabled={isLoading}
          />
        </HStack>
      </HStack>
      <Divider />
    </Box>
  );
};
